import { StatusCodes, useApiCreate } from '@/composables/api'
import { Post } from '@/model/data-object/Post'
import { ref, Ref } from 'vue'
import useAppState from '@/composables/ui/ui'
import { ApiTimeout } from '@/composables/apiTimeout'
import useAnalyticsManager, {
  ANALYTICS_EVENT_POST_REPORT_CONFIRMATION,
} from '@/composables/analytics/analyticsManager'

const TIMEOUT_DOMAIN = 'forum_widget_post_report_'
const TIMEOUT_DOMAIN_PUB = 'forum_widget_post_report_pub_'

export default function usePostReport(post: Post) {
  const { loggedIn } = useAppState()
  const alreadyPerformed: Ref<boolean> = ref(false)
  const calledReportAction: Ref<boolean> = ref(false)

  const { loading: isReporting, request, statusCode } = loggedIn.value
    ? useApiCreate<Post>(
        '/api/prv/v1/postReport/' + post.id,
        {},
        {},
        new ApiTimeout(TIMEOUT_DOMAIN + post.id)
      )
    : useApiCreate<Post>(
        '/api/pub/v1/postReport/' + post.id,
        {},
        {},
        new ApiTimeout(TIMEOUT_DOMAIN_PUB + post.id, true, 5, [
          StatusCodes.OK,
          StatusCodes.CREATED,
        ])
      )

  const reportPost = async () => {
    const { propagateAnalyticsEvent } = useAnalyticsManager()
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_REPORT_CONFIRMATION)
    await request()
    calledReportAction.value = true
    if (statusCode.value === StatusCodes.OK) {
      alreadyPerformed.value = true
    } else if (statusCode.value === StatusCodes.CREATED) {
      alreadyPerformed.value = false
    }
  }

  return {
    isReporting,
    alreadyPerformed,
    calledReportAction,
    reportPost,
  }
}
